export enum InvestigationRecommendationCode {
	Save = "SAVE",
	ReferToProsecutionSection = "REFER_TO_PROSECUTION_SECTION",
	ReferToPublicProsecution = "REFER_TO_PUBLIC_PROSECUTION",
}
